(function () {
  'use strict';


  angular
    .module('operationsSummaryReport', [
      'ui.router'
    ]);
}());
